import { render, staticRenderFns } from "./padlet_collection.vue?vue&type=template&id=74d6d4a0&scoped=true&"
import script from "./padlet_collection.vue?vue&type=script&lang=js&"
export * from "./padlet_collection.vue?vue&type=script&lang=js&"
import style0 from "./padlet_collection.vue?vue&type=style&index=0&id=74d6d4a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d6d4a0",
  null
  
)

export default component.exports